import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

export default class ContactMe extends Component {
  render() {
    return (
      <React.Fragment>
        <Container className="mt-100 mt-60">
          <Row className="justify-content-center">
            <div className="col-12 text-center">
              <div className="section-title">
                <h4 className="title mb-4">
                  Mon style vous plaît ?
                </h4>
                <p className="text-muted para-desc mx-auto">
                  N'hésitez pas à me{" "}
                  <span className="text-primary font-weight-bold">contacter</span>
                  , je me ferai un plaisir d'échanger avec vous, et c'est sans engagement de votre part !
                </p>

                <Link to="/contact" type="submit" className="btn btn-pills btn-primary">
                  Contacter
                </Link>
              </div>
            </div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
